import React from 'react';
import { PropTypes } from 'prop-types';
import './NewPlanDetails.scss';

// const getSpeedString = (plan) => {
//   if (plan) {
//     return `${plan.download.description}/${plan.upload.description}`;
//   }
//   return null;
// };

const NewPlanDetails = props => (
  <div className="row">
    <div className="col-sm-12 success-plan-box">
      {/* <div className="plan-box">
        <div className={'success-price'}>
          {props.plan.price}
          {props.plan.isContract &&
          <div className={'success-bill-period'}>
            per month on a {props.plan.term} term
          </div>
          }
          {!props.plan.isContract &&
          <div className={'success-bill-period'}>
            per month
          </div>
          }
        </div>
      </div> */}
      <div className="plan-box plan-details">
        {props.address &&
        <div>
          <div className="plan-details-title">New Address</div>
          <div className="plan-details-text2">{props.address}</div>
        </div>
        }
        <div className="plan-details-title">Unlimited Broadband</div>

        <div className="plan-details-subtitle">with {props.plan.label}</div>
        {/* <div className="plan-details-text1">{getSpeedString(props.plan)}</div> */}
        {props.plan.isContract && !props.isChange &&
        <div className="plan-details-text1">{props.isByoModemSelected ? 'You have opted to use your own modem' : 'Free Modem and standard connection fee'}</div>
        }
        {!props.plan.isContract && !props.isChange &&
        <div className="plan-details-text1">{props.isByoModemSelected ? 'Standard connection fee' : 'Modem and standard connection fee'}</div>
        }
        {props.offer && props.offer.enabled &&
        <div className={`${!props.isChange ? 'plan-details-text2' : 'plan-details-text1'}`}>Plus Christmas Gift {props.offer.name}</div>
        }
      </div>
    </div>
  </div>
);

NewPlanDetails.defaultProps = {
  plan: { isContract: false }
};

NewPlanDetails.propTypes = {
  address: PropTypes.string,
  isChange: PropTypes.bool,
  plan: PropTypes.object,
  offer: PropTypes.object,
  isByoModemSelected: PropTypes.bool
};

export default NewPlanDetails;



/** WEBPACK FOOTER **
 ** ./src/components/NewPlanDetails/NewPlanDetails.js
 **/